import axios, { Axios } from 'axios';
import { BlofinContext } from '../../blofin-provider/auth/BlofinProvider';
import { useContext, useEffect, useMemo, useState } from 'react';

type ColorData = {
  color: string;
  country: string;
};

const useColor = () => {
  const [open, setOpen] = useState(false);

  const { state } = useContext(BlofinContext);

  const { baseUrl, http = axios } = state;

  const [colorState, setColorState] = useState<ColorData>();

  const getIpState = async <T>() => {
    return (http as Axios).get<T>(`${baseUrl}/uapi/v1/cms/color`) as Promise<T>;
  };

  const getState = async () => {
    try {
      const res = await getIpState<{ data: ColorData }>();
      setColorState(res.data);
      if (res.data.color === 'YELLOW') {
        setOpen(true);
      }
      if (res.data.color === 'GREEN') {
        sessionStorage.setItem('ipFlag', JSON.stringify(false));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const isUk = useMemo(() => {
    return colorState?.country.toLocaleUpperCase() === 'GB' ? true : false;
  }, [colorState]);

  useEffect(() => {
    const ipFlag = sessionStorage.getItem('ipFlag');
    if (ipFlag && JSON.parse(ipFlag)) {
      setOpen(false);
    } else {
      getState();
    }
  }, []);

  return {
    open,
    setOpen,
    colorState,
    isUk,
  };
};

export default useColor;
